/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-04 14:58:19
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-04 14:58:24
 * @FilePath: \zhucai_user\src\util\errorCode.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  401: '认证失败，无法访问系统资源',
  403: '当前操作没有权限',
  404: '访问资源不存在',
  default: '系统未知错误，请反馈给管理员'
}
